import api from '@src/api';
import { apiClient } from '@src/clients';
import { MODELS_ALLOWED_CHANGE_DETECTION } from '@src/utils/constants/MODE_INFERENCE_DEFAULTS';
import { JOB_STATUS } from '@src/utils/constants/WORKFLOW_CONSTANTS';

export const GetInference = async url => {
  let response = await api.dexter.get(url);
  return response.data;
};

export const GetInferencePoll = async url => {
  let response = await api.DexterPoll.get(url);
  return response.data;
};

export const GetInferencesByAOIAndBlockName = async args => {
  const [aoi_id, blockName] = args;
  const response = await apiClient.dexter.inferencesList({ aoi_id });
  const inferences = response.data.filter(
    i =>
      i.metadata.block_name === blockName &&
      JOB_STATUS.completed.includes(i.status)
  );
  return inferences;
};

export const GetInferencesForChangeDetection = async args => {
  const [aoi_id] = args;
  const response = await apiClient.dexter.inferencesList({ aoi_id });
  const inferences = response.data.filter(
    i =>
      JOB_STATUS.completed.includes(i.status) &&
      MODELS_ALLOWED_CHANGE_DETECTION.includes(i.metadata.block_name)
  );

  return inferences;
};

export const UpdateInference = async (id, payload) => {
  const response = await api.dexter.patch(
    `/v1alpha1/inferences/${id}`,
    payload
  );
  return response.data;
};

export const getInferenceById = async id => {
  const response = await apiClient.dexter.inferencesDetail(id);
  return response.data;
};
